/** @file Rotate tool pointer: shared transform press with the rotate gizmo. */
import type { ToolPointer } from '../../panels/viewport/viewportTypes';
import { rotateGesture } from '../transform/rotateGesture';
import { transformIdle } from '../transform/transformIdle';
import { transformPress } from '../transform/transformPress';

/** Rotate ring around the gizmo bone. */
export const rotatePointer: ToolPointer = { press: (ctx, p) => transformPress(ctx, p, 'rotate', rotateGesture), idle: (ctx) => transformIdle(ctx, 'rotate') };
